import { useEffect } from 'react';

import { PrivatePage } from '../../components/private-page';
import { ctGameDefault, ctGameTitle } from '../../constants/text';
import NetworkOrganisationsGrid from '../../features/network-organisations-grid';

export default function NetworkOrganisations() {
  useEffect(() => {
    document.title = ctGameTitle + ' - Organisations';
    return () => {
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <>
      <PrivatePage
        className={'page-base--full'}
        breadcrumb={[
          { label: 'Dashboard', href: 'dashboard' },
          { label: 'Organisations', href: 'networkorganisations' }
        ]}
        pageTitle={'Organisations'}>
        <NetworkOrganisationsGrid />
      </PrivatePage>
    </>
  );
}
